module.exports = {"menuItem":{"labels":{"title":"SAUVEGARDE","save":"Sauvegarde","saveBackToList":"et retour à la liste","saveBackToAdd":"et ajouter un nouveau","preparePreview":"Préparer la prévisualisation","warning":"La page n'est pas sauvegardée, gardez cette fenêtre ouverte","preview":"Liens de prévisualisation"}}}


//////////////////
// WEBPACK FOOTER
// ./components/Custom/MenuItem/admin-fr.json
// module id = Wuxp
// module chunks = 18